import { call, put, takeLeading } from 'redux-saga/effects'
import I18n from 'i18n'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import { getConversations } from 'api/chat/Get'
import * as fromActions from '../../actions/chat.action'

function handleGetConversations({ token, loggedUserIsAdmin }: any) {
  return getConversations(token, loggedUserIsAdmin)
}

function* getConversationsListEffectSaga(action: any) {
  try {
    const data = yield call(handleGetConversations, action.payload)
    yield put(fromActions.Actions.getConversationsSuccess(data))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* getConversationsListWatcherSaga() {
  yield takeLeading(
    fromActions.GET_CONVERSATIONS,
    getConversationsListEffectSaga
  )
}
